import React from 'react';
import PropTypes from 'prop-types';

/**
 * A React component that calculates and displays the estimated reading time of an article.
 *
 * @param {object} props - The component props.
 * @param {string} props.articleContent - The string content of the article (can include HTML).
 */
const ReadingTime = ({ articleContent }) => {

  // If no content is provided, return nothing to avoid errors.
  if (!articleContent) {
    return null;
  }

  // Define the average reading speed in words per minute (WPM).
  // A common value is 200-250 WPM. Adjust as needed.
  const WORDS_PER_MINUTE = 200;

  // 1. Sanitize the content: remove HTML tags to get a clean text string.
  const textContent = articleContent.replace(/<[^>]*>/g, '');

  // 2. Count the number of words.
  // The \s+ regex matches any whitespace character (space, tab, etc.) one or more times.
  // The filter(Boolean) removes any empty strings that might result from multiple spaces.
  const wordCount = textContent.split(/\s+/).filter(Boolean).length;

  // 3. Calculate the estimated reading time in minutes.
  // Use Math.ceil to round up to the next whole number, ensuring a minimum of 1 minute.
  const readingTime = Math.ceil(wordCount / WORDS_PER_MINUTE);

  return (
    <>
      {readingTime}
    </>
  );
};

ReadingTime.propTypes = {
  articleContent: PropTypes.string.isRequired,
};


export default ReadingTime;